import { render, staticRenderFns } from "./top-ten-clicks.vue?vue&type=template&id=25936576"
import script from "./top-ten-clicks.vue?vue&type=script&lang=js"
export * from "./top-ten-clicks.vue?vue&type=script&lang=js"
import style0 from "./top-ten-clicks.vue?vue&type=style&index=0&id=25936576&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports